import { OpportunityQueryKey } from "configs/opportunity.config";
import AppLayout from "layouts/appLayout/AppLayout";
import { breadcrumbItems } from "pages/application/contstants";
import { useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { OpportunityController } from "services/opportunity/controller";
import { AccordionProvider, Breadcrumb, Button, Link } from "stories";
import OpportunityCard from "../../index/elements/opportunityCard/OpportunityCard";
import LoanDetailsBorrower from "./elements/borrower/LoanDetailsBorrower";
import LoanDetailsGuarantors from "./elements/guarantors/LoanDetailsGuarantors";
import LoanDetailsMembers from "./elements/members/LoanDetailsMembers";
import LoanDetailsOverview from "./elements/overview/LoanDetailsOverview";
import classes from "./LoanDetails.module.scss";

const opportunityController = OpportunityController();

const LoanDetails = () => {
  const params = useParams();
  const queryClient = useQueryClient();
  const queryKey = [OpportunityQueryKey, { id: params.id }];
  const { isLoading, data: opportunity } = useQuery({
    queryKey,
    queryFn: opportunityController.getById.bind(null, params.id),
  });

  const refetch = useCallback(() => {
    queryClient.invalidateQueries(queryKey);
  }, [queryClient]); //eslint-disable-line

  return (
    <AppLayout
      title={"Complete full details about the opportunity"}
      hideSidebar
      backButton
    >
      <Helmet>
        <title>Loan Details | Fundever</title>
      </Helmet>
      <Breadcrumb items={breadcrumbItems} selectedId={0} />
      <div className={classes["main-wrapper"]}>
        <div className={"mb-3"}>
          <OpportunityCard readOnly loading={isLoading} data={opportunity} />
        </div>
        {opportunity && (
          <AccordionProvider scrollOnChange>
            <LoanDetailsOverview onUpdate={refetch} opportunity={opportunity} />
            <LoanDetailsBorrower />
            <LoanDetailsGuarantors />
            <LoanDetailsMembers />
          </AccordionProvider>
        )}
        <Row className={"mt-4"}>
          <Col xs={7} />
          <Col>{/* <Button outline label={"Publish Now"} /> */}</Col>
          <Col>
            <Link to={"../proposed-project"}>
              <Button label={"Next Step"} />
            </Link>
          </Col>
        </Row>
      </div>
    </AppLayout>
  );
};

export default LoanDetails;
